import React, { useState } from 'react';
import HabitItem from './HabitItem';

function App() {
  const [linkHovered, setLinkHovered] = useState(false);

  return (
    <div className="h-screen bg-bg-dark text-text-primary font-system flex flex-col p-4 overflow-hidden">

      {/* Main Content */}
      <div className="flex-1 flex flex-col gap-16 items-center justify-center">
        {/* Hero Section */}
        <div className="flex flex-col items-center text-center max-w-2xl">
          <div className="flex items-center justify-center gap-3 text-2xl font-black">
            Nawykomierz
          </div>
          <h1 className="text-6xl md:text-7xl font-black text-text-primary -tracking-wider mt-2">
            Buduj nawyki<br />
            <span className="inline-block bg-accent-orange text-bg-dark px-4 py-2 rounded-lg -rotate-3 font-black text-4xl md:text-4xl mt-2 -tracking-wider">prosto</span>
          </h1>

        </div>

        {/* Widget */}
        <div className="flex flex-col items-center gap-2">
          <HabitItem
            name="Joga"
          />

          <p className="text-[11px] text-text-muted text-center tracking-wide">
            Przytrzymaj dzień, aby zapisać wykonanie
          </p>
        </div>

        {/* Download */}
        <div className="flex flex-col items-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.mmc.nawykomierz"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity duration-200"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png"
              alt="Pobierz z Google Play"
              className="h-16"
            />
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center text-text-muted text-[10px] mt-auto pb-2">
        <p className="mt-1">
          <a
            href="/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            className={``}
          
          >
            Polityka Prywatności
          </a>
          <p className="m-0">© 2026 Nawykomierz. Aplikacja Android dostępna w Google Play.</p>
        </p>
      </div>
    </div>
  );
}

export default App;
